import React from 'react'
import InputSong from 'Components/SongComponents/FormSongs/InputSong/InputSong'
import FormSong from 'Components/SongComponents/FormSong'
import {
  ActionButton,
  ActionContainer,
  Container,
} from './NeedProfilerInfo.styled'
import { IntakeFlowStep } from '../../constants'

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
  onBackStep: () => void
  onMoreProfileInfoSave: (websiteUrl: string, ein: string) => void
  ein?: string
  websiteUrl?: string
}

export const NeedProfilerInfo = ({
  onNextStep,
  onBackStep,
  onMoreProfileInfoSave,
  ein,
  websiteUrl,
}: Props) => {
  const handleSubmit = (data: any) => {
    onMoreProfileInfoSave(data.websiteUrl.trim(), data.ein.trim())
    onNextStep(IntakeFlowStep.TOP_PRIORITIES)
  }

  return (
    <Container>
      {' '}
      <FormSong onSubmit={handleSubmit} id='MoreProfileInfoForm'>
        <InputSong
          label='Employer Identification Number (EIN)'
          name='ein'
          type='ein'
          helperText='No dashes'
          defaultValue={ein || ''}
          size={12}
        />
        <InputSong
          label='Website'
          name='websiteUrl'
          type='url'
          defaultValue={websiteUrl || ''}
          size={12}
        />
      </FormSong>
      <ActionContainer>
        <ActionButton variant='text' onClick={() => onBackStep()}>
          Back
        </ActionButton>
        <ActionButton
          variant='contained'
          color='primary'
          type='submit'
          form='MoreProfileInfoForm'
        >
          Next
        </ActionButton>
      </ActionContainer>
    </Container>
  )
}
